import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/active.svg',
})
export class ActiveComponent {}
